<template>
  <el-main>
    <banner></banner>
    <first-message></first-message>
    <why-marathon></why-marathon>
    <service-content></service-content>
    <commercial-value></commercial-value>
    <customer-example></customer-example>
    <get-more></get-more>
  </el-main>
</template>

<script>
import Banner from '../../components/Banner'
import FirstMessage from './components/FirstMessage'
import WhyMarathon from './components/WhyMarathon'
import ServiceContent from './components/ServiceContent'
import CommercialValue from './components/CommercialValue'
import CustomerExample from './components/CustomerExample'
import GetMore from '../../components/GetMore'

export default {
  name: 'Home',
  components: {
    Banner,
    FirstMessage,
    WhyMarathon,
    ServiceContent,
    CommercialValue,
    CustomerExample,
    GetMore
  }
}
</script>

<style scoped lang="stylus">
  .el-header
    height: auto
  .el-main
    padding: 20px 0
    overflow: hidden
  .el-footer
    height: auto
</style>



// WEBPACK FOOTER //
// src/pages/home/Home.vue